"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ".info-block {\n  background: #f4f4f4;\n  padding: 1rem 1rem 1rem 1rem;\n  margin-bottom: 1rem;\n  display: flex;\n  justify-content: space-between;\n  text-align: start; }\n  .info-block.loose {\n    padding: 0;\n    background: none; }\n  .info-block .info-content span.label {\n    display: block;\n    color: #e41b13;\n    font-size: 12px;\n    line-height: 1.33; }\n  .info-block .info-content p {\n    font-size: 14px;\n    margin-bottom: 16px;\n    line-height: 1.29; }\n    .info-block .info-content p:last-child {\n      margin-bottom: 0; }\n  .info-block .actions {\n    width: 1.5rem;\n    margin-left: 1.5rem; }\n    .info-block .actions svg {\n      margin-bottom: 1rem; }\n      .info-block .actions svg:last-child {\n        margin-bottom: 0; }\n      .info-block .actions svg:hover {\n        cursor: pointer; }\n      .info-block .actions svg[disabled] {\n        opacity: 0.5;\n        cursor: not-allowed; }\n";
  const fileName = "InfoBlock_InfoBlock";
  const element = document.querySelector("style[data-sass-component='InfoBlock_InfoBlock']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const InfoBlock = props => {
  const classes = ['info-block', props.loose ? 'loose' : null].filter(item => item);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.join(' ')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'info-content'
  }, props.children), props.actionIcons && props.actionIcons.length && /*#__PURE__*/_react.default.createElement("div", {
    className: 'actions'
  }, props.actionIcons));
};
InfoBlock.propTypes = {
  actionIcons: _propTypes.default.array
};
var _default = exports.default = InfoBlock;